
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"18","viewBox":"0 0 17 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.834 2.2c-.626 0-1.133.507-1.133 1.133v11.334c0 .626.507 1.133 1.133 1.133h7.933c.627 0 1.134-.507 1.134-1.133V3.333c0-.626-.508-1.133-1.134-1.133H2.834zm10.063.384c.083.236.137.485.137.75v11.333a2.26 2.26 0 01-.665 1.602l.42.067c.617.097 1.198-.325 1.296-.943l1.768-11.194a1.133 1.133 0 00-.942-1.297l-2.014-.318zM6.8 5.034c.116 0 .22.043.31.103l.026.007c1.006.819 3.064 2.848 3.064 4.14a1.983 1.983 0 01-1.984 1.983 1.96 1.96 0 01-1.207-.422c.291.777.75 1.255 1.314 1.575v.001a.283.283 0 01-.107.546H5.384a.283.283 0 01-.106-.546v-.001c.563-.32 1.022-.798 1.314-1.575a1.96 1.96 0 01-1.208.422 1.983 1.983 0 01-1.983-1.984c0-1.291 2.057-3.32 3.063-4.139l.027-.007a.552.552 0 01.31-.104z","fill":"#667187"}})])
          )
        }
      }
    